/*
 * @Author: Shirtiny
 * @Date: 2021-06-08 17:06:56
 * @LastEditTime: 2021-06-09 15:20:14
 * @Description:
 */
import data from "services/data";

const addFakePlugins = async () => {
  const arr = Array(300);
  arr.fill(1, 0, arr.length);
  console.log(arr);
  const promise = arr.map((v, i) =>
    data.addPlugin({
      appId: `app_id_${i}`,
      module: `插件${i}号`,
      installPath: `plugins/nginx${i}`,
      info: `这是插件${i}号的简介`,
      aliasName: `${i}号`,
    })
  );
  Promise.allSettled(promise);
};

const fakeData = {
  addFakePlugins,
};

export default fakeData;
